import { drag, Selection } from "d3"
import { D3TimeBasedVisualization } from "./D3TimeBasedVisualization"
import { D3GraphsOverlay } from "./TimeSeriesGraphGroup/D3/D3GraphsOverlay"
export function attachD3WheelAndDragListeners(selection: Selection<any, any, any, any>, visualization: D3TimeBasedVisualization<any, any, any, any>, overlay: D3GraphsOverlay) {
    // Attach listeners to the SVG to handle scroll and drag events.
    // By attaching the listeners to the SVG and forwarding the event to the appropriate child components, 
    // we can avoid the issue of Annotations capturing scroll and drag events just because they are on top.
    const onDrag = (event: any) => { 
        if (visualization.config.liveModeEnabled) {
			return
		}

        overlay.onDrag(event)
        visualization.onPan(event)
    }

    const onDragEnd = () => { 
        if (visualization.config.liveModeEnabled) {
			return
		}

        visualization.autoScale()
    }

    const dragBehavior = drag<any, any, any>()
        .on("drag", onDrag)
        .on("end", onDragEnd)

    selection
        .on("wheel", visualization.onWheel)
        .on("mouseenter", overlay.onHover)
        .on("mousemove", overlay.onHover)
        .on("mouseleave", overlay.onMouseLeave)
        // A click without a drag places the cursor line, in windows that have one.
        .on("click.cursor", overlay.onClick)
        .call(dragBehavior)
}
